import React, { useState } from 'react';
import { FaBars, FaTimes, FaGithub, FaLinkedin, FaBlog } from 'react-icons/fa';
import resumePDF from '../assets/Shalender-resume-2026.pdf'; // adjust path if needed

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  React.useEffect(() => {
    const sectionIds = ['home', 'about', 'skills', 'experience', 'projects', 'contact'];

    const handleScroll = () => {
      const scrollPosition = window.scrollY + 120;

      for (const id of sectionIds) {
        const section = document.getElementById(id);
        if (!section) continue;
        const top = section.offsetTop;
        const bottom = top + section.offsetHeight;

        if (scrollPosition >= top && scrollPosition < bottom) {
          setActiveSection(id);
          break;
        }
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
      setIsMenuOpen(false);
    }
  };

  const navLinkClass = (sectionId) =>
    `relative pb-1 font-medium transition-colors after:absolute after:left-0 after:bottom-0 after:h-0.5 after:bg-blue-600 after:transition-all after:duration-300 ${
      activeSection === sectionId
        ? 'text-blue-600 after:w-full'
        : 'text-gray-700 hover:text-blue-600 after:w-0 hover:after:w-full'
    }`;

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-md z-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <span className="text-2xl font-bold text-gray-900">
              Shalender Kumar
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={navLinkClass('home')}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={navLinkClass('about')}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('skills')}
              className={navLinkClass('skills')}
            >
              Skills
            </button>
            <button
              onClick={() => scrollToSection('experience')}
              className={navLinkClass('experience')}
            >
              Experience
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className={navLinkClass('projects')}
            >
              Projects
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={navLinkClass('contact')}
            >
              Contact
            </button>

            {/* Resume Link */}
            <a
              href={resumePDF}
              download
              className="relative pb-1 text-gray-700 hover:text-blue-600 font-medium transition-colors after:absolute after:left-0 after:bottom-0 after:h-0.5 after:w-0 after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full"
            >
              Download Resume
            </a>
          </nav>

          {/* Social Links */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="https://www.linkedin.com/in/shalender8928/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              <FaLinkedin size={20} />
            </a>
            <a
              href="https://github.com/shalender8928/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              <FaGithub size={20} />
            </a>
            <a
              href="https://codinghelpsolutions.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              <FaBlog size={20} />
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t">
              <button
                onClick={() => scrollToSection('home')}
                className={`block px-3 py-2 font-medium w-full text-left transition-colors ${
                  activeSection === 'home' ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className={`block px-3 py-2 font-medium w-full text-left transition-colors ${
                  activeSection === 'about' ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('skills')}
                className={`block px-3 py-2 font-medium w-full text-left transition-colors ${
                  activeSection === 'skills' ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                Skills
              </button>
              <button
                onClick={() => scrollToSection('experience')}
                className={`block px-3 py-2 font-medium w-full text-left transition-colors ${
                  activeSection === 'experience' ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                Experience
              </button>
              <button
                onClick={() => scrollToSection('projects')}
                className={`block px-3 py-2 font-medium w-full text-left transition-colors ${
                  activeSection === 'projects' ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                Projects
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className={`block px-3 py-2 font-medium w-full text-left transition-colors ${
                  activeSection === 'contact' ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                Contact
              </button>
              <a
                href={resumePDF}
                download
                className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium w-full text-left transition-colors"
              >
                Download Resume
              </a>
              <div className="flex items-center space-x-4 px-3 py-2">
                <a
                  href="https://www.linkedin.com/in/shalender8928/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-blue-600 transition-colors"
                >
                  <FaLinkedin size={20} />
                </a>
                <a
                  href="https://github.com/shalender8928/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-blue-600 transition-colors"
                >
                  <FaGithub size={20} />
                </a>
                <a
                  href="https://codinghelpsolutions.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-blue-600 transition-colors"
                >
                  <FaBlog size={20} />
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
